document.addEventListener("DOMContentLoaded", function () {
  if (typeof loadKiwiSizingChart !== "function") {
    console.error(
      "loadKiwiSizingChart() function is not defined globally, please add Kiwi snippet in the theme /snippets."
    );
    return;
  }

  /*flag to prevent double reinjection here, do not remove*/
  let reinjectionInProgress = false;

  function checkAndInjectKiwiChart() {
    const kiwiContainer = document.querySelector(".ks-chart-container");

    if (!kiwiContainer && !reinjectionInProgress) {
      reinjectionInProgress = true;
      loadKiwiSizingChart();

      setTimeout(() => {
        reinjectionInProgress = false;
      }, 200); 
    }
  }

  function handleVariantChange() {
    setTimeout(checkAndInjectKiwiChart, 100);
  }

  document.addEventListener("click", function (event) {
    if (event.target.closest(".swatch, .option-label-wrapper")) {
      handleVariantChange();
    }
  });

  document.addEventListener("change", function (event) {
    if (event.target.closest(".swatch, .option-label-wrapper")) {
      handleVariantChange();
    }
  });

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.removedNodes.forEach(function (node) {
        if (node.nodeType === 1 && node.matches("div.ks-chart-container.sizing-chart-container.ks-container-with-modal")) {
          checkAndInjectKiwiChart();
        }
      });
    });
  });

  const observerConfig = { childList: true, subtree: true };
  observer.observe(document.body, observerConfig);
});
